export default __webpack_public_path__ + "static/test-979f35b11497834afde3d757094c9128.mp4";